import styled from "styled-components";
import theme from "../../../styles/theme";
import { Button } from "@mui/material";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from "react-responsive-carousel";

export const CenteredContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
  width: 100%;
  padding: 24px;
  background: #f8f9fa;
`;

export const InfoCard = styled.div`
  background: #fff;
  border-radius: 12px;
  padding: 32px;
  max-width: 720px;
  width: 100%;
  box-shadow: 0 6px 24px rgba(18, 38, 63, 0.06);
  text-align: center;
`;

export const IconWrapper = styled.div`
  color: ${theme.colors.blue.primary};
  svg {
    font-size: 64px;
  }
  margin-bottom: 16px;
`;

export const CardTitle = styled.h1`
  font-family: "Roboto", sans-serif;
  font-size: 24px;
  color: #202124;
  margin: 8px 0 12px;
`;

export const CardSubtitle = styled.p`
  font-family: "Roboto", sans-serif;
  color: #5f6368;
  margin-bottom: 24px;
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #fff;
  width: 100%;
  overflow-y: auto;
  /* height: 100vh; */
`;
export const TopContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-between;
  margin-top: clamp(12px, 3vh, 32px);
  padding-inline: clamp(16px, 5vw, 80px);
  align-items: center;
  gap: 12px;

  @media (${theme.devices.tablet}) {
    flex-wrap: wrap;
    justify-content: center;
  }
`;
export const LogoImg = styled.img`
  height: clamp(36px, 5vh, 64px);
  width: auto;
`;

export const Btn = styled.button`
  background-color: ${theme.colors.blue.primary};
  border-radius: 52px;
  height: 35px;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  color: white;
  font-family: roboto;
  padding-inline: 1vw;
  border-color: ${theme.colors.blue.primary};

  @media (${theme.devices.tablet}) {
    padding-inline: 4vw;
  }
`;
export const BtnSmall = styled.button`
  background-color: ${theme.colors.blue.primary};
  font-size: ${theme.fontSize.xsm};
  border-color: ${theme.colors.blue.primary};
  border-radius: 52px;
  height: 25px;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  color: white;
  padding-inline: 1vw;
  @media (${theme.devices.tablet}) {
    padding-inline: 4vw;
  }
`;
export const BtnLabel = styled.span`
  font-family: ${theme.fonts.gilroyBold};
  color: white;
`;
export const TopDetailsContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: stretch;
  width: min(1280px, 92vw);
  margin-top: clamp(16px, 4vh, 40px);
  gap: clamp(16px, 2vw, 28px);
  @media (${theme.devices.tablet}) {
    flex-direction: column;
    width: 92vw;
    gap: 20px;
  }
  /* margin-inline: 4vw; */
`;

export const TopDetailsContainerLeft = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1 1 0;
  width: 100%;
  /* margin-left: 7vw; */
  color: black;
  min-width: 0;
  .left-title {
    font-family: ${theme.fonts.gilroySemiBold};
    font-size: ${theme.fontSize.xlg};
    color: #5f6368;
    align-self: center;
    text-align: center;
    margin-bottom: clamp(12px, 2vh, 24px);
    @media (${theme.devices.tablet}) {
      text-align: -webkit-center;
    }
    @media (${theme.devices.laptop}) {
      font-size: ${theme.fontSize.lg};
    }
  }
  .row-left {
    display: grid;
    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr) minmax(0, 1.2fr);
    width: 100%;
    align-items: stretch;
    gap: clamp(12px, 1.5vw, 20px);
    @media (${theme.devices.tablet}) {
      grid-template-columns: 1fr;
      row-gap: 3vh;
      overflow: visible;
    }
  }

  @media (${theme.devices.tablet}) {
    display: flex;
    flex-direction: column;
  }
`;

export const Companyinfo = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  color: #5f6368;
  align-items: center;
  justify-content: center;
  /* margin-left: 3vw; */
  .company-logo {
    width: clamp(120px, 12vw, 200px);
    height: clamp(120px, 12vw, 200px);
    margin-top: 8px;
    border-radius: 50%;
    object-fit: cover;
  }
  .company-name {
    font-family: ${theme.fonts.gilroyBold};
    font-size: ${theme.fontSize.md2};
    align-self: center;
    margin-bottom: 8px;
    @media (${theme.devices.laptop}) {
      font-size: ${theme.fontSize.md};
    }
  }
  .company-data {
    font-family: ${theme.fonts.gilroyRegular};
    font-size: ${theme.fontSize.mm};
    align-self: center;
    margin-bottom: -2px;
  }
  @media (${theme.devices.tablet}) {
    flex: none;
  }
`;

export const CompanyActions = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: center;
  justify-content: center;
  row-gap: 10px;

  > * {
    width: 100%;
    max-width: 240px;
  }

  @media (${theme.devices.tablet}) {
    > * {
      max-width: 100%;
    }
  }
`;

export const ImagePlaceholder = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 80%;
  max-height: 35vh;
  background-color: #f8f9fa;
  border: 2px dashed #e0e0e0;
  border-top-left-radius: 25px;
  border-top-right-radius: 25px;
  color: #5f6368;
  font-family: "Roboto", sans-serif;
  text-align: center;
  padding: 20px;

  @media (${theme.devices.tablet}) {
    width: 100%;
    height: 250px;
  }
`;

export const StyledButton = styled(Button)`
  && {
    background-color: ${theme.colors.blue.primary};
    border-radius: 52px;
    height: 35px;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    font-family: ${theme.fonts.gilroyBold};
  }
`;

export const CompanyCarousel = styled.div`
  display: flex;
  width: 100%;
  min-height: 250px;
  max-height: 100%;
  align-items: stretch;
  justify-content: center;
  text-align: center;

  @media (${theme.devices.tablet}) {
    min-height: 220px;
  }
`;
export const StyledCarousel = styled(Carousel)`
  .carousel .slide img {
    max-height: 320px;
    object-fit: cover;
    border-top-left-radius: 25px;
    border-top-right-radius: 25px;
    width: 100%;
  }
  .carousel.carousel-slider {
    width: 100% !important;
    max-width: 420px;
    max-height: 100%;
    @media (${theme.devices.tablet}) {
      width: 100% !important;
    }
  }
  .carousel .control-dots {
    margin-top: 10px;
  }

  .carousel .control-dots .dot {
    background-color: #d9d9d9;
    opacity: 0.7;
  }

  .carousel .control-dots .dot.selected {
    background-color: ${theme.colors.blue.primary};
    opacity: 1;
  }

  .carousel .thumbs-wrapper {
    display: none;
  }
  .carousel .carousel-status {
    margin-right: 10px;
    margin-top: 5px;
  }
`;
export const TopDetailsContainerRight = styled.div`
  display: flex;
  flex-direction: column;
  flex: 0 0 320px;
  width: 100%;
  color: black;
  min-width: 280px;
  /* margin-right: 7vw; */

  @media (${theme.devices.laptopS}) {
    flex-basis: 300px;
  }

  @media (${theme.devices.tablet}) {
    margin-top: 0;
    min-width: 0;
    flex-basis: auto;
  }
`;
export const SliderContainer = styled.div`
  display: flex;
  width: 100%;
  margin-top: 4px;
  margin-left: 0;
  @media (${theme.devices.tablet}) {
    margin-left: 0px;
    width: 100%;
  }
`;

export const VerticalCards = styled.div`
  display: flex;
  flex: none;
  flex-direction: column;
  align-items: center;
  background-color: white;
  padding: 1rem 0.75rem;
  border-radius: 15px;
  box-shadow: 3px 4px 6px 3px rgba(0, 0, 0, 0.1);
  width: 100%;
  margin-top: 14px;
  margin-left: 0;
  row-gap: 12px;
  @media (${theme.devices.tablet}) {
    width: 100%;
    flex-direction: row;
    margin-left: 0px;
    align-self: center;
    column-gap: 10px;
  }
  @media (${theme.devices.laptop}) {
    row-gap: 10px;
  }
`;
export const VerticalItem = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #5f6368;
  flex: 1;
  place-content: center;
  .icon {
    width: 35px;
  }
  .label {
    font-family: ${theme.fonts.gilroySemiBold};
    font-size: ${theme.fontSize.lg};
    @media (${theme.devices.laptop}) {
      margin-top: 0.5vh;
      font-size: ${theme.fontSize.md2};
    }
  }
  .description {
    font-family: ${theme.fonts.gilroyRegular};
    font-size: ${theme.fontSize.md};
    margin-top: -10px;
    text-align: center;
    @media (${theme.devices.tablet}) {
      font-size: ${theme.fontSize.mm};
    }
    @media (${theme.devices.laptop}) {
      margin-top: 0.5vh;
      font-size: ${theme.fontSize.mm};
    }
  }
`;

export const CardsRow = styled.div`
  display: flex;
  flex-wrap: wrap; /* Permite que os itens quebrem linha */
  flex-direction: row;
  column-gap: 3vw;
  row-gap: 3vh; /* Adiciona espaçamento vertical entre as linhas no layout responsivo */
  margin-top: 3vh;
  width: 100%;
  justify-content: center;
  @media (${theme.devices.laptop}) {
    margin-top: 13vh;
  }

  @media (${theme.devices.tablet}) {
    /* Aplica estilos para dispositivos móveis */
    column-gap: 2vw;
    row-gap: 1vh;
    flex-direction: row;
  }
`;

export const HotizontalCard = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  background-color: white;
  padding: 1rem;
  border-radius: 15px;
  box-shadow: 3px 4px 6px 3px rgba(0, 0, 0, 0.1);
  width: 15vw; /* Tamanho padrão para desktops */
  height: 10vh;
  color: #5f6368;
  justify-content: space-between;
  @media (${theme.devices.laptop}) {
    height: 15vh;
  }

  @media (${theme.devices.tablet}) {
    width: 38vw;
    height: auto;
    flex-direction: column;
  }

  .left-container {
    display: flex;
  }

  .right-container {
    display: flex;
    flex-direction: column;
    .trend-value {
      font-family: "Roboto", sans-serif;
      font-size: ${theme.fontSize.mm};
    }
  }

  .icon-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    row-gap: 1vh;

    .icon {
      width: 50px;
      @media (${theme.devices.tablet}) {
        width: 40px;
      }
    }

    .label {
      font-family: ${theme.fonts.gilroyRegular};
      font-size: ${theme.fontSize.mm};
      text-align: center;
      width: 100%;
      @media (${theme.devices.tablet}) {
        font-size: ${theme.fontSize.mm};
      }
    }
  }

  .value {
    font-family: ${theme.fonts.gilroySemiBold};
    font-size: ${theme.fontSize.xlg};
    margin-left: auto;
    margin-right: 1vw;
    @media (${theme.devices.tablet}) {
      font-size: ${theme.fontSize.lg};
      margin-left: 0px;
      margin-right: 0px;
    }
  }
`;
export const GraphicsContainer = styled.div`
  display: flex;
  flex: 2;
  flex-direction: row;
  width: 70vw;
  column-gap: 5vw;
  margin-bottom: 4vh;
  margin-top: 4vh;
  justify-content: center;
  @media (${theme.devices.tablet}) {
    display: flex;
    flex-direction: column;
    width: 85%;
    row-gap: 3vh;
    flex: none;
  }
  @media (${theme.devices.laptop}) {
    column-gap: 2vw;
  }
`;

export const GraphicsCard = styled.div`
  display: flex;
  /* flex: 1; */
  width: fit-content;
  flex-direction: column;
  color: #5f6368;
  background-color: white;
  padding: 1rem;
  border-radius: 15px;
  box-shadow: 3px 4px 6px 3px rgba(0, 0, 0, 0.1);

  .top-title {
    font-family: ${theme.fonts.gilroySemiBold};
    font-size: ${theme.fontSize.md2};
    text-align: center;
  }
  .info-container {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    margin-left: 2vw;
    margin-right: 2vw;
    margin-bottom: 1vh;

    .left-data {
      display: flex;
      flex-direction: column;
      .top-data {
        font-family: ${theme.fonts.gilroySemiBold};
        font-size: ${theme.fontSize.xlg};
      }
      .data-description {
        font-family: ${theme.fonts.gilroyRegular};
        font-size: ${theme.fontSize.mm};
        margin-top: -10px;
      }
    }

    .right-data {
      display: flex;
      flex-direction: column;
      align-items: center;
      .trend-value {
        font-family: "Roboto", sans-serif;
        font-size: ${theme.fontSize.mm};
      }
    }
  }
  .graphic {
    display: flex;
    width: 650px;
    height: 300px;
    @media (${theme.devices.tablet}) {
      width: 300px;
      height: 200px;
    }
    @media (${theme.devices.laptop}) {
      width: 550px;
      height: 250px;
    }

    /* margin: 0 auto; */
  }
  .bottom-row {
    display: flex;
    flex-direction: row;
    column-gap: 1vw;
    margin-top: 1vw;
    margin-left: 2vw;
  }
`;
export const SectionIntro = styled.div`
  display: flex;
  flex-direction: column;
  color: #5f6368;
  align-items: center;
  margin-bottom: 4vh;
  margin-top: 4vh;
  .title {
    font-family: ${theme.fonts.gilroyBold};
    font-size: ${theme.fontSize.lg};
  }
  .description {
    font-family: ${theme.fonts.gilroyRegular};
    font-size: ${theme.fontSize.mm};
    margin-top: 2vh;
  }
  .action {
    margin-top: 1.5vh;
  }
  @media (${theme.devices.tablet}) {
    text-align: -webkit-center;
  }
`;
export const RankedKeyWords = styled.div`
  display: flex;
  width: 75vw;
  flex-direction: column;
  background-color: white;
  padding: 1rem;
  border-radius: 15px;
  box-shadow: 3px 4px 6px 3px rgba(0, 0, 0, 0.1);
  margin-bottom: 7vh;
  scrollbar-width: thin; /* Estilo do scroll para navegadores compatíveis */
  scrollbar-color: ${theme.colors.blue.primary} rgba(0, 0, 0, 0.1);

  &::-webkit-scrollbar {
    width: 8px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #5f6368;
    border-radius: 8px;
  }

  &::-webkit-scrollbar-track {
    background-color: rgba(0, 0, 0, 0.05);
  }
  .title {
    font-family: ${theme.fonts.gilroyBold};
    font-size: ${theme.fontSize.md2};
    color: #5f6368;
    align-self: center;
    margin-top: 1vh;
    @media (${theme.devices.tablet}) {
      text-align: -webkit-center;
    }
  }
  @media (${theme.devices.tablet}) {
    width: 85vw; /* Ocupa mais espaço na tela */
  }
`;

export const Table = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
  margin-top: 2vh;
`;

export const Row = styled.div`
  display: flex;
  align-items: center;
  gap: 15px;
  padding: 5px;
`;

export const Image = styled.img`
  width: 50px;
  height: 50px;
  border-radius: 50%;
  object-fit: cover;
  @media (${theme.devices.tablet}) {
    display: none;
  }
`;

export const Description = styled.p`
  flex: 1;
  margin: 0;
  font-family: ${theme.fonts.gilroyBold};
  font-size: ${theme.fontSize.mm};
  color: #5f6368;
  @media (${theme.devices.tablet}) {
    font-size: ${theme.fontSize.mm};
  }
`;
export const TableDataRow = styled.div`
  display: flex;
  flex-direction: row;
  column-gap: 1vw;
  @media (${theme.devices.tablet}) {
    flex-direction: column;
    row-gap: 1vh;
  }
`;

export const DescriptionTop = styled.p`
  flex: 1;
  margin: 0;
  font-family: ${theme.fonts.gilroySemiBold};
  font-size: ${theme.fontSize.mm};
  color: #808186;
`;

export const Balloon = styled.span<{ color: string }>`
  padding: 6px;
  border-radius: 20px;
  font-family: ${theme.fonts.gilroyBold};
  font-size: ${theme.fontSize.mm};
  color: white;
  background-color: ${(props) => props.color};
  width: 302px;
  text-align-last: center;
  text-align: center;
  @media (${theme.devices.tablet}) {
    width: 100px;
    font-size: ${theme.fontSize.mm};
  }
`;

export const InteractionsContainer = styled.div`
  display: flex;
  flex-direction: row;
  column-gap: 2vw;
  min-width: 77vw;
  height: 40vh;
  flex: 4;
  margin-bottom: 6vh;
  @media (${theme.devices.laptop}) {
    margin-inline: 5vw;
  }
  @media (${theme.devices.tablet}) {
    flex-direction: column;
    width: 85vw;
    height: auto;
    margin-bottom: 0vh;
  }
`;
export const MainAvaliationContainer = styled.div`
  display: flex;
  flex: 3;
  flex-direction: column;
  background-color: white;
  padding: 1rem;
  border-radius: 15px;
  box-shadow: 3px 4px 6px 3px rgba(0, 0, 0, 0.1);
  margin-bottom: 7vh;
  height: inherit;
  .title {
    font-family: ${theme.fonts.gilroyBold};
    font-size: ${theme.fontSize.md};
    color: #5f6368;
    align-self: center;
  }
  .data-container {
    display: flex;
    flex-direction: column;
    row-gap: 1.5vh;
    overflow-y: auto;
    margin-top: 4vh;
    scrollbar-width: thin;
    scrollbar-color: ${theme.colors.blue.primary} rgba(0, 0, 0, 0.1);
  }
  .data-container::-webkit-scrollbar {
    width: 8px;
  }
  .data-container::-webkit-scrollbar-thumb {
    background-color: #5f6368;
    border-radius: 8px;
  }

  .data-container::-webkit-scrollbar-track {
    background-color: rgba(0, 0, 0, 0.05);
  }
`;
export const AvaliationItem = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 2vw;
  .details {
    display: flex;
    flex-direction: column;
    color: #5f6368;
    .title-avaliation {
      font-family: ${theme.fonts.gilroyBold};
      font-size: ${theme.fontSize.mm};
      display: flex;
      column-gap: 5px;
      @media (${theme.devices.tablet}) {
        text-align: -webkit-center;
        flex-direction: column;
      }
    }
    .description {
      font-family: ${theme.fonts.gilroyRegular};
      font-size: ${theme.fontSize.mm};
      @media (${theme.devices.tablet}) {
        text-align: -webkit-center;
      }
    }
  }
  .rating-container {
    display: flex;
    margin-left: auto;
    margin-right: 1vw;
    @media (${theme.devices.tablet}) {
      margin-left: 0px;
      margin-right: 0px;
    }
  }
  @media (${theme.devices.tablet}) {
    flex-direction: column;
    margin-bottom: 4vh;
  }
`;

export const RemainSearch = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  background-color: white;
  padding: 1rem;
  border-radius: 15px;
  box-shadow: 3px 4px 6px 3px rgba(0, 0, 0, 0.1);
  margin-bottom: 7vh;
  height: inherit;

  .title {
    font-family: ${theme.fonts.gilroyBold};
    font-size: ${theme.fontSize.md};
    color: #5f6368;
    align-self: center;
    text-align: -webkit-center;
    /* width: 50%; */
  }
  .data-container {
    display: flex;
    flex-direction: column;
    row-gap: 1.5vh;
    overflow-y: auto;
    margin-top: 4vh;
    scrollbar-width: thin;
    scrollbar-color: ${theme.colors.blue.primary} rgba(0, 0, 0, 0.1);
  }
  .data-container::-webkit-scrollbar {
    width: 8px;
  }
  .data-container::-webkit-scrollbar-thumb {
    background-color: #5f6368;
    border-radius: 8px;
  }

  .data-container::-webkit-scrollbar-track {
    background-color: rgba(0, 0, 0, 0.05);
  }
`;
export const RemainSearchItem = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  .remain-title {
    font-family: ${theme.fonts.gilroyRegular};
    font-size: ${theme.fontSize.mm};
    color: #5f6368;
  }
  .remain-position {
    font-family: ${theme.fonts.gilroyBold};
    font-size: ${theme.fontSize.xsm};
    background-color: ${theme.colors.blue.primary};
    color: white;
    width: 25px;
    text-align-last: center;
    border-radius: 6px;
    margin-right: 0.5vw;
  }
`;
export const PostContainer = styled.div`
  display: flex;
  margin-bottom: 10vh;
  margin-top: -4vh;
  .data-container {
    display: flex;
    flex-direction: row;
    row-gap: 1.5vh;
    overflow-x: auto;
    margin-top: 4vh;
    scrollbar-width: thin;
    scrollbar-color: ${theme.colors.blue.primary} rgba(0, 0, 0, 0.1);
    width: 77vw;
  }
  .data-container::-webkit-scrollbar {
    width: 8px;
  }
  .data-container::-webkit-scrollbar-thumb {
    background-color: #5f6368;
    border-radius: 8px;
  }

  .data-container::-webkit-scrollbar-track {
    background-color: rgba(0, 0, 0, 0.05);
  }
  @media (${theme.devices.tablet}) {
    margin-top: 0vh;
  }
`;

export const PostItem = styled.div`
  display: flex;
  flex-direction: column;
  background-color: white;
  padding: 1rem;
  border-radius: 15px;
  box-shadow: 3px 4px 6px 3px rgba(0, 0, 0, 0.1);
  color: #5f6368;
  margin-bottom: 2vh;
  margin-right: 1vw;
  margin-left: 1vw;
  width: min-content;
  min-width: 240px;
  .image-post {
    width: 210px;
    height: 150px;
    object-fit: cover;
  }
  .post-title {
    font-family: ${theme.fonts.gilroyBold};
    font-size: ${theme.fontSize.mm};
    color: #5f6368;
    margin-top: 2vh;
    margin-bottom: 0.5vh;
  }
  .post-description {
    font-family: ${theme.fonts.gilroyRegular};
    font-size: ${theme.fontSize.xsm};
  }
  .post-btn {
    display: flex;
    margin-top: 0.5vh;
    margin-left: auto;
  }
  @media (${theme.devices.tablet}) {
    min-width: 60vw;
  }
`;
